(function () {
  "use strict";

  // Alterna o dark mode
  $(".dark-mode").on("click", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $("body:not(.no-dark)").toggleClass("dark");
    if (!localStorage.getItem("dark_mode")) {
      localStorage.setItem("dark_mode", 1);
    } else {
      localStorage.removeItem("dark_mode");
    }
  });
  if (localStorage.getItem("dark_mode")) {
    $(".dark-mode").addClass("active");
    $("body:not(.no-dark)").addClass("dark");
  }
})();
